// src/pages/backoffice/MenuList.jsx
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import MenuFormModal from "./menuFormModal";
import GenerateQrModal from "./generateQrModal";
import { getApiClient } from "../../libs/axiosInstance";
import { Link } from "react-router";

const axios = getApiClient();


export default function MenuList() {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showQR, setShowQR] = useState(null);
  const [showForm, setShowForm] = useState(null); // menu object or null
  
  useEffect(() => {
    fetchMenus();
  }, []);

  async function fetchMenus() {
    setLoading(true);
    try {
      const res = await axios.get("/api/myshop/menus");
      setMenus(res.data.menus || []);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load menus", "error");
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(menu) {
    const ok = await Swal.fire({
      title: `Delete ${menu.name}?`,
      text: "This cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });
    if (!ok.isConfirmed) return;

    try {
      await axios.delete(`/api/myshop/menus/${menu._id}`);
      Swal.fire("Deleted", "Menu removed", "success");
      fetchMenus();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to delete", "error");
    }
  }

  return (
    <div className="container py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="m-0">E-Menus</h4>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => setShowForm({})}
        >
          + New Menu
        </button>
      </div>

      {loading ? (
        <div className="text-center p-3">
          <div className="spinner-border" />
        </div>
      ) : menus.length === 0 ? (
        <div className="alert alert-light text-center">No menus yet.</div>
      ) : (
        <table className="table table-sm align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th style={{ width: 160 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {menus.map((m) => (
              <tr key={m._id}>
                <td>{m.name}</td>
                <td>
                  {m.isActive ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </td>
                <td>
                  <Link
                    className="btn btn-sm btn-outline-primary me-1"
                    to={`/manage-menu/${m._id}/edit`}
                  >
                    Edit
                  </Link>
                  <button
                    className="btn btn-sm btn-outline-dark me-1"
                    onClick={() => setShowQR(m)}
                  >
                    QR
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(m)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showQR && (
        <GenerateQrModal
          menuId={showQR._id}
          tableId={showQR._id}
          onClose={() => setShowQR(null)}
        />
      )}

      {showForm && (
        <MenuFormModal
          initial={showForm}
          onClose={() => setShowForm(null)}
          onSaved={() => {
            setShowForm(null);
            fetchMenus();
          }}
        />
      )}
    </div>
  );
}
